import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, FormControl, FormGroup } from 'react-bootstrap';
import BasicPage from '../../components/BasicPage';
import ListErrors from '../../components/ListErrors';
import { AuthRouteProps } from './interfaces';

@inject('authStore', 'routing')
@observer
export default class Confirm extends React.Component<AuthRouteProps> {
  public handleCodeChange = (e: any) => this.props.authStore.setCode(e.target.value);
  public handleEmailChange = (e: any) => this.props.authStore.setEmail(e.target.value);
  public handleSubmitForm = (e: any) => {
    e.preventDefault();
    this.props.authStore
      .confirmCode()
      .then(() => this.props.routing.history.replace('/login'));
  }

  public render() {
    const { values, errors, inProgress } = this.props.authStore;

    return (
      <BasicPage title="Confirm code">
        <p>Check your email for a confirmation code.</p>

        <ListErrors errors={errors} />

        <form onSubmit={this.handleSubmitForm}>
          <FormGroup>
            <FormControl
              type="email"
              placeholder="Email"
              value={values.email}
              onChange={this.handleEmailChange}
            />
          </FormGroup>
          <FormGroup>
            <FormControl
              type="text"
              placeholder="Code"
              onChange={this.handleCodeChange}
            />
          </FormGroup>

          <Button
            bsSize="large"
            bsStyle="primary"
            type="submit"
            disabled={inProgress}
          >
            Confirm
          </Button>
        </form>
      </BasicPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/container/Account/Confirm.tsx